// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('discountManagement.discounts', {
        url: '/discounts?show&canc&appr&comp&months&filter&currPage&pageSize',
        views: {
            'discountList@discountManagement': {
                templateUrl: 'main/discountManagement/discounts/discounts.tpl.html',
                controller: 'DiscountsController as vm'
            }
        },
        resolve: {
            searchTerms: searchTermsResolver,
            discounts: discountsResolver
        }
    });
}

// @ngInject
function discountsResolver($stateParams, DiscountsApiService){
    return DiscountsApiService.getDiscounts($stateParams.filter, $stateParams.currPage, $stateParams.pageSize,  $stateParams.canc, $stateParams.appr, $stateParams.comp, $stateParams.months);
}

// @ngInject
function searchTermsResolver($stateParams) {
    return {
        showDropDown : $stateParams.show,
        filter: $stateParams.filter ? $stateParams.filter : '',
        currentPage: $stateParams.currPage,
        pageSize : $stateParams.pageSize,
        showCancelled: $stateParams.canc,
        showApproved: $stateParams.appr,
        showCompleted: $stateParams.comp,
        monthsBack: $stateParams.months
    };
}

// @ngInject
function DiscountsController($scope ,$rootScope, $state, $stateParams, discounts, loadSpinnerService, DiscountsApiService, ToasterService, confirmationDialogService, $translate, searchTerms) {
    var vm = this;

    vm.filter = '';
    vm.discounts = discounts.data.results;
    vm.selectedDiscountId = 0;
    vm.filterDropdownIsVisisble = false;
    vm.showCancelled = false;
    vm.showCompleted = false;
    vm.showApproved = false;
    vm.monthsOptions = [0, 1, 2, 4, 6, 8, 12, 9999]
    vm.monthsBackOption = 0;
    vm.currentDate = new Date();
    vm.currentPage = discounts.data.page;
    vm.pageSize = discounts.data.limit;
    vm.totalDiscounts = discounts.data.total;

    vm.searchTermChanged = searchTermChanged;
    vm.forceReloadUrl = forceReloadUrl;
    vm.selectDiscount = selectDiscount;
    vm.selectedDiscountId = 0;
    vm.listBackgroundStyle = listBackgroundStyle
    vm.flipDropDownFilter = flipDropDownFilter;
    vm.flipCancelled = flipCancelled;
    vm.flipApproved = flipApproved;
    vm.flipCompleted = flipCompleted;
    vm.monthChanged = monthChanged;
    vm.claimCanCreate = claimCanCreate;

    //$scope.$watch(function() { return vm.showCancelled; }, function(oldValue, newValue) {
    //    searchTermChanged(true);
    //});
    //$scope.$watch(function() { return vm.showCompleted; }, function(oldValue, newValue) {
    //    searchTermChanged(true);
    //});
//#region OldCalendarStuff
    // properties
    vm.discountsOld = [
        { 
            'name': "Test Rabatt",
            'code': "XHGY21",
            'startDate': new Date(2022, 1, 10),
            'endDate': new Date(2022, 1, 16),
            'description': "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet tellus cras adipiscing enim eu turpis. Bibendum arcu vitae elementum curabitur vitae nunc sed velit. Risus nec feugiat in fermentum posuere."
        },
        { 
            'name': "Test Rabatt 2",
            'code': "XHGY22",
            'startDate': new Date(2022, 1, 1),
            'endDate': new Date(2022, 1, 8),
            'description': "Nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Nullam non nisi est sit amet. Nisi lacus sed viverra tellus in hac habitasse platea dictumst. Ullamcorper dignissim cras tincidunt lobortis feugiat."
        },
        { 
            'name': "Test Rabatt 3",
            'code': "XHGY23",
            'startDate': new Date(2022, 2, 2),
            'endDate': new Date(2022, 2, 10),
            'description': "Quis vel eros donec ac odio tempor orci. Tempus urna et pharetra pharetra massa massa ultricies mi."
        },
        { 
            'name': "Test Rabatt 4",
            'code': "XHGY24",
            'startDate': new Date(2022, 1, 12),
            'endDate': new Date(2022, 1, 18),
            'description': "Duis tristique sollicitudin nibh sit amet commodo nulla facilisi. Mus mauris vitae ultricies leo integer malesuada nunc vel risus. Consectetur libero id faucibus nisl tincidunt."
        },
        { 
            'name': "Test Rabatt 5",
            'code': "XHGY25",
            'startDate': new Date(2022, 4, 1),
            'endDate': new Date(2022, 4, 31),
            'description': "Duis tristique sollicitudin nibh sit amet commodo nulla facilisi. Mus mauris vitae ultricies leo integer malesuada nunc vel risus. Consectetur libero id faucibus nisl tincidunt."
        }
    ];
    //vm.selectedDiscount = discount;
    vm.dates = [];
    vm.selectedMonth = new Date().getMonth();
    vm.selectedYear = new Date().getFullYear();

    vm.increaseMonth = increaseMonth;
    vm.decreaseMonth = decreaseMonth;
    vm.shouldDisplayDiscount = shouldDisplayDiscount;
    vm.getColspanForDiscount = getColspanForDiscount;
    vm.shouldSkipRepeat = shouldSkipRepeat;

    vm.months = [
        { 'name': "jan", 'days': [] },
        { 'name': "feb", 'days': [] },
        { 'name': "mar", 'days': [] },
        { 'name': "apr", 'days': [] },
        { 'name': "may", 'days': [] },
        { 'name': "jun", 'days': [] },
        { 'name': "jul", 'days': [] },
        { 'name': "aug", 'days': [] },
        { 'name': "sep", 'days': [] },
        { 'name': "oct", 'days': [] },
        { 'name': "nov", 'days': [] },
        { 'name': "dec", 'days': [] },
    ]

    var weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
//#endregion
    activate();

    function activate() {   
        vm.filterDropdownIsVisisble = searchTerms.showDropDown ? searchTerms.showDropDown == 'true' ? true : false : false;
        vm.filter = searchTerms.filter ? searchTerms.filter : '';
        vm.showCancelled = searchTerms.showCancelled ? searchTerms.showCancelled == 'true' ? true : false : false;
        vm.showApproved = searchTerms.showApproved ? searchTerms.showApproved == 'true' ? true : false : false;
        vm.showCompleted = searchTerms.showCompleted ? searchTerms.showCompleted == 'true' ? true : false : false;
        vm.monthsBackOption = searchTerms.monthsBack ? searchTerms.monthsBack: 0;

        recalcDaysInMonths();

        console.log(vm.months);

        //$rootScope.$on('Discount.Changed', function () {
        //    loadDiscounts();
        //});
    }

    function claimCanCreate(){
        return (!_.isUndefined($rootScope.currentUser.claims.discount) && !_.isUndefined($rootScope.currentUser.claims.discount.create)) || $rootScope.currentUser.claims.discount.create
    }

    function searchTermChanged(reloadUrl){
        
        if(reloadUrl){
            forceReloadUrl();
        }

        loadDiscounts();
    }

    function forceReloadUrl(){
        $state.go('discountManagement.discounts', 
        {
            currPage: vm.currentPage,
            pageSize: vm.pageSize,
            show: vm.filterDropdownIsVisisble,
            filter: vm.filter,
            canc: vm.showCancelled,
            appr: vm.showApproved,
            comp: vm.showCompleted,
            months: vm.monthsBackOption
        },
            {notify: false}
        );
    }

    function loadDiscounts() {
        console.log(vm.filterDropdownIsVisisble, vm.filter, vm.showCompleted, vm.showApproved, vm.showCancelled, vm.monthsBackOption);
        loadSpinnerService.start('mainSpinner');
        DiscountsApiService.getDiscounts(vm.filter, vm.currentPage, vm.pageSize,  vm.showCancelled, vm.showApproved, vm.showCompleted, vm.monthsBackOption).then(function (response) {
            console.log(response);
            vm.discounts = response.data.results;
            vm.currentPage = response.data.page;
            vm.pageSize = response.data.limit;
            vm.totalDiscounts = response.data.total;

        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function selectDiscount(discount) {
        vm.selectedDiscountId = discount.id;
        $state.go('discountManagement.discounts.discount', 
            {
                discountId: discount.id,
                currPage: vm.currentPage,
                pageSize: vm.pageSize,
                show: vm.filterDropdownIsVisisble,
                filter: vm.filter,
                canc: vm.showCancelled,
                appr: vm.showApproved,
                comp: vm.showCompleted,
                months: vm.monthsBackOption
            }
        );
    }

    function listBackgroundStyle(discount){
        var style = {};

        if(discount.status === 'discount.Approved')
            style['background-color'] = 'rgba(0,255,0,0.06)';
        else if(discount.status === 'discount.Cancelled')
            style['background-color'] = 'rgba(255,0,0,0.03)';
        
        return style;
    }

    function monthChanged() {
        if(vm.monthsBackOption < 0)
            vm.monthsBackOption = vm.monthsOptions[0];
        if(vm.monthsBackOption >= vm.monthsOptions.length)
            vm.monthsBackOption = vm.monthsOptions.length - 1;

        searchTermChanged(true);
    }
    function flipDropDownFilter() {
        vm.filterDropdownIsVisisble = !vm.filterDropdownIsVisisble;
        forceReloadUrl();
    }
    function flipCancelled() {
        vm.showCancelled = !vm.showCancelled;
        searchTermChanged(true);
    }
    function flipApproved() {
        vm.showApproved = !vm.showApproved;
        searchTermChanged(true);
    }
    function flipCompleted() {
        vm.showCompleted = !vm.showCompleted;
        searchTermChanged(true);
    }

    function recalcDaysInMonths(){
        _.forEach(vm.months, function(month){
            month.days = [];
            var daysInMonth = 0;
            if(month.name === 'jan' || month.name === 'mar' || month.name === 'may' || month.name === 'jul' || month.name === 'aug' || month.name === 'oct' || month.name === 'dec'){
                daysInMonth = 31;
            }
            else if(month.name === 'apr' || month.name === 'jun' || month.name === 'sep' || month.name === 'nov'){
                daysInMonth = 30
            }
            else if(month.name === 'feb'){
                daysInMonth = leapYear(vm.selectedYear) ? 29 : 28;
            }

            for(let i = 1; i <= daysInMonth; i++){
                var day = weekday[new Date(vm.selectedYear, vm.selectedMonth, i).getDay()];
                month.days.push({ 'index': i, 'name': day });
            }
        });
    }

    function increaseMonth(){
        vm.selectedMonth++;
        if(vm.selectedMonth >= 12){
            vm.selectedMonth = 0;
            vm.selectedYear++;
            recalcDaysInMonths();
        }
    }
    
    function decreaseMonth(){
        vm.selectedMonth--;
        if(vm.selectedMonth < 0){
            vm.selectedMonth = 11;
            vm.selectedYear--;
            recalcDaysInMonths();
        }
    }

    function shouldDisplayDiscount(discount, day){
        //console.log(vm.selectedYear + " - " +  discount.startDate.getFullYear());
        if(vm.selectedYear === discount.startDate.getFullYear() || vm.selectedYear === discount.endDate.getFullYear()){
            //console.log(vm.selectedMonth + " - " +  discount.startDate.getMonth());
            if(vm.selectedMonth === discount.startDate.getMonth() || vm.selectedMonth === discount.endDate.getMonth()){
                //console.log(day.index + " - " +  discount.startDate.getDate());
                if(day.index >= discount.startDate.getDate() && day.index <= discount.endDate.getDate()){
                    return true;
                }
                return false;
            }
            return false;
        }
        return false;
    }

    function daysBetween(startDate, endDate) {
        var millisecondsPerDay = 24 * 60 * 60 * 1000;
        return (endDate - startDate) / millisecondsPerDay;
    }

    
    function shouldSkipRepeat(discount, day){
        if(shouldDisplayDiscount(discount, day)){
            if(day.index > discount.startDate.getDate() && day.index <= discount.endDate.getDate()){
                return true;
            }
        }

        return false;        
    }

    function getColspanForDiscount(discount, day){
        var colspan = 1;

        if(shouldDisplayDiscount(discount, day)){
            if(discount.startDate.getDate() === day.index){
                colspan += daysBetween(discount.startDate, discount.endDate);
            }
        }

        return colspan;
    }

    function leapYear(year)
    {
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }
}

angular.module('discountManagement.discounts', ['discounts.api', 'discounts.discount'])
    .config(stateConfig)
    .controller('DiscountsController', DiscountsController);
